import type { MenuProps as AntMenuProps } from 'antd';
import React from 'react';
import {
  MenuContainer,
  MenuTitle,
  StyledMenu,
  SubMenuPopupGlobalStyles
} from './styled';

export interface MenuProps extends Omit<AntMenuProps, 'title' | 'className'> {
  title?: React.ReactNode;
  className?: string;
}

export const Menu: React.FC<MenuProps> = ({
  title,
  className = '',
  ...props
}) => {
  return (
    <>
      {/* @ts-expect-error - GlobalStyleComponent from styled-components has type compatibility issues with React types */}
      <SubMenuPopupGlobalStyles />
      <MenuContainer
        className={`${className} ${title ? 'has-title' : 'no-title'}`}
      >
        {!!title && <MenuTitle variant="body2">{title}</MenuTitle>}
        <StyledMenu className={className} {...props} />
      </MenuContainer>
    </>
  );
};
